import axios from 'axios'

interface IPlaceForZip {
  country: string
  'country abbreviation': string
  places: {
    latitude: string
    longitude: string
    'place name': string
    state: string
    'state abbreviation': string
  }[]
  'post code': string
}

export const getProperCountyList = async (zipCode: string | number) => {
  const { data } = await axios.create().get<IPlaceForZip>(`https://api.zippopotam.us/us/${zipCode}`)

  return data
}
